import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";

import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { db,storage } from "../firebase";

const COLLECTION = "emailTemplates";



export async function getEmailTemplates() {
  const snap = await getDocs(collection(db, COLLECTION));
  const templates = {};
  snap.forEach((docSnap) => {
    templates[docSnap.id] = docSnap.data();
  });
  return templates;
}

/** Fetch a single template by id (useful from the Node/Brevo send side too). */
export async function getEmailTemplate(templateId) {
  const snap = await getDoc(doc(db, COLLECTION, templateId));
  return snap.exists() ? snap.data() : null;
}

/**
 * Saves/updates one template. Uses merge:true so partial updates (e.g. just
 * the instruction text) never wipe out the rest of the doc.
 * payload shape: { subject, body, instruction?, images? }
 */
export async function saveEmailTemplate(templateId, payload) {
  const ref = doc(db, COLLECTION, templateId);
  await setDoc(
    ref,
    {
      ...payload,
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
  return true;
}

/**
 * Uploads one image for a template (used by the 5-image uploader on the
 * "Itinerary + Pass" template) and returns its public download URL.
 */
export async function uploadEmailTemplateImage(file, templateId) {
  const path = `emailTemplates/${templateId}/${Date.now()}_${file.name}`;
  const fileRef = storageRef(storage, path);
  await uploadBytes(fileRef, file);
  return getDownloadURL(fileRef);
}